
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-charcoal via-navy to-charcoal">
      {/* Geometric Overlay */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none z-0">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hexagons" x="0" y="0" width="100" height="87" patternUnits="userSpaceOnUse">
              <path d="M50 0L93.3 25L93.3 62L50 87L6.7 62L6.7 25Z" fill="none" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hexagons)" />
        </svg>
      </div>

      <Navigation />

      <main className="relative z-10">
        {/* Hero Header */}
        <section className="pt-32 pb-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            {/* Breadcrumb */}
            <div className="flex items-center justify-center space-x-2 mb-6 text-gold text-sm">
              <Link to="/" className="hover:text-warmGold transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span>Privacy</span>
            </div>

            <h1 className="text-white text-5xl md:text-6xl font-bold mb-4">
              Privacy Policy
            </h1>
            <p className="text-gold text-base tracking-wider">CCPA Compliant - Updated 2026</p>
          </div>
        </section>

        {/* Policy Content */}
        <section className="pb-24 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-darkCard border-l-4 border-gold p-12 rounded-lg">
              {/* Compliance Badge */}
              <div className="border-2 border-gold rounded-lg p-8 mb-12 text-center bg-gold/5">
                <div className="flex items-center justify-center space-x-3 mb-3">
                  <i className="ri-shield-star-line text-gold text-4xl w-10 h-10 flex items-center justify-center"></i>
                  <h2 className="text-gold text-3xl font-bold">CCPA 2026 COMPLIANT</h2>
                </div>
                <p className="text-lightGray text-base">
                  California Consumer Privacy Act Certified
                </p>
              </div>

              {/* Data Usage */}
              <div className="mb-12">
                <div className="flex items-center space-x-3 mb-4">
                  <i className="ri-database-2-line text-gold text-3xl w-8 h-8 flex items-center justify-center"></i>
                  <h2 className="text-white text-3xl font-bold">What We Collect</h2>
                </div>
                <div className="w-10 h-1 bg-gold mb-6"></div>
                <p className="text-lightGray text-lg leading-loose mb-6">
                  We collect minimal data strictly for transaction processing and logistics coordination. The information we gather includes:
                </p>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Name and business contact information</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Email address for transaction communications</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Business information relevant to asset transactions</span>
                  </li>
                </ul>
                <div className="bg-gold/10 border border-gold/30 rounded-lg p-6">
                  <p className="text-gold font-semibold text-lg">
                    We collect minimal data strictly for transactions and logistics.
                  </p>
                </div>
              </div>

              {/* Third Parties */}
              <div className="mb-12">
                <div className="flex items-center space-x-3 mb-4">
                  <i className="ri-lock-line text-gold text-3xl w-8 h-8 flex items-center justify-center"></i>
                  <h2 className="text-white text-3xl font-bold">Data Sharing</h2>
                </div>
                <div className="w-10 h-1 bg-gold mb-6"></div>
                <p className="text-lightGray text-lg leading-loose mb-6">
                  We do not sell, rent, or trade your personal information to third parties. Your data privacy is paramount to our business operations.
                </p>
                <div className="bg-lightGray/5 border-2 border-gold/20 rounded-lg p-6">
                  <p className="text-white text-lg font-semibold mb-2">Logistics Partners Only</p>
                  <p className="text-lightGray">
                    Information is only shared with trusted logistics partners to facilitate asset transport and delivery. These partners are contractually obligated to maintain data confidentiality.
                  </p>
                </div>
              </div>

              {/* Your Rights */}
              <div className="mb-8">
                <div className="flex items-center space-x-3 mb-4">
                  <i className="ri-shield-user-line text-gold text-3xl w-8 h-8 flex items-center justify-center"></i>
                  <h2 className="text-white text-3xl font-bold">Your California Rights</h2>
                </div>
                <div className="w-10 h-1 bg-gold mb-6"></div>
                <p className="text-lightGray text-lg leading-loose mb-8">
                  Under the California Consumer Privacy Act (CCPA), you have the right to:
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Know what personal information we collect and how it's used</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Request deletion of your personal information</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Opt-out of the sale of personal information (we don't sell data)</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold mt-1.5">•</span>
                    <span className="text-lightGray text-lg">Non-discrimination for exercising your privacy rights</span>
                  </li>
                </ul>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="mailto:info@nextlifeasset.com?subject=Data%20Deletion%20Request"
                    className="inline-block px-8 py-3 bg-gold text-black rounded-full font-semibold hover:bg-warmGold transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
                  >
                    Request Data Deletion
                  </a>
                  <a
                    href="mailto:info@nextlifeasset.com?subject=Do%20Not%20Sell%20My%20Info"
                    className="inline-block px-8 py-3 border-2 border-gold text-white rounded-full font-semibold hover:bg-gold hover:text-black transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
                  >
                    Do Not Sell My Info
                  </a>
                </div>
              </div>

              {/* Contact Section */}
              <div className="border-t border-gold/20 pt-8">
                <p className="text-white text-lg mb-4">Questions about privacy?</p>
                <a
                  href="mailto:info@nextlifeasset.com"
                  className="text-gold hover:text-warmGold text-2xl font-semibold transition-colors cursor-pointer"
                >
                  info@nextlifeasset.com
                </a>
                <p className="text-lightGray mt-2">
                  <a href="tel:408-581-3979" className="hover:text-gold transition-colors cursor-pointer">408-581-3979</a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
